import { navigateToKnowledgeBaseArticle } from '../../navigation/actions/navigateToKnowledgeBaseArticle';
import { updateIsOnSearchMode } from '../../visitor-widget/reducers/isOnSearchMode';
import { getCurrentView } from '../../current-view/selectors/getCurrentView';
import { getIsOnSearchMode } from '../../visitor-widget/selectors/getIsOnSearchMode';
import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { EVENT_NAMES } from '../../usage-tracking/constants/eventNames';
export const handleArticleClick = (articleId, href, browserWindowHeight, searchTerm) => (dispatch, getState) => {
  const currentView = getCurrentView(getState());
  const lastSearchModeEnabled = getIsOnSearchMode(getState());
  dispatch(updateIsOnSearchMode(false));
  dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
    action: 'clicked-kb-article'
  }));
  dispatch(navigateToKnowledgeBaseArticle({
    deepLink: href,
    hubSpotContentId: `${articleId}`,
    hubSpotContentTextFragment: ''
  }, browserWindowHeight, {
    view: currentView,
    searchTerm,
    lastSearchModeEnabled
  }));
};